import { paginationOptions, navigationOptions } from "Config/slider/default"
import { productsSliderOptions, articleProductsSliderOptions, accessoriesSliderOptions, indexArticleSliderOptions } from "Config/slider/product"
import { benefitsSliderOptions } from "Config/slider/benefits";
import { indexBannerSliderOptions } from "Config/slider/index-banner"
import { testimonialsSliderOptions } from "Config/slider/testimonials"

import { rSwiperVisibleItems } from 'Functions/swiper-visible-items'
import { rSwiperCssNavFix } from 'Functions/swiper-css-nav-fix'
import { EffectFade, Navigation, Pagination, Autoplay } from 'swiper';

export const sliderOptions = instance => {
    // default options
    let options = {
        simulateTouch: false,
        watchOverflow: true,
        preventInteractionOnTransition: true,
        roundLengths: true,
        modules: [Pagination, Navigation, EffectFade, Autoplay, rSwiperVisibleItems, rSwiperCssNavFix]
    }

    if (instance.paginationEl) {
        options = {...options, ...paginationOptions(instance)}
    }

    if (instance.prevEl && instance.nextEl) {
        options = {...options, ...navigationOptions(instance)}
    }

    if (instance.hasAttribute('r-slider-products')) {
        const maxVisibleItems = instance.hasAttribute('r-max-visible-items') ? instance.getAttribute('r-max-visible-items') : 10
        const spaceBetween = instance.hasAttribute('r-space-between') ? instance.getAttribute('r-space-between') : 0
        options = {...options, ...productsSliderOptions(instance, options, maxVisibleItems, spaceBetween)}
    }

    if (instance.hasAttribute('r-article-products-slider')) {
        options = {...options, ...articleProductsSliderOptions(instance, options)}
    }

    if (instance.hasAttribute('r-benefits-slider')) {
        options = {...options, ...benefitsSliderOptions(instance, options)}
    }

    if (instance.hasAttribute('r-slider-index-banner')) {
        options = {...options, ...indexBannerSliderOptions(instance, options)}
    }
    
    if (instance.hasAttribute('r-accessories-slider')) {
        options = {...options, ...accessoriesSliderOptions(instance, options)}
    }

    if (instance.hasAttribute('r-testimonials-slider')) {
        options = {...options, ...testimonialsSliderOptions(instance, options)}
    }
    
    if (instance.hasAttribute('r-index-article-slider')) {
        options = {...options, ...indexArticleSliderOptions(instance, options)}
    }

    return {...options, ...instance.customOptions}
}